/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceTypeResponse } from '../../models/device-type-response';

export interface GetDeviceTypes$Params {
}

export function getDeviceTypes(http: HttpClient, rootUrl: string, params?: GetDeviceTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceTypeResponse>> {
  const rb = new RequestBuilder(rootUrl, getDeviceTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceTypeResponse>;
    })
  );
}

getDeviceTypes.PATH = '/api/v1/device_types';
